import { Link, useInRouterContext } from 'react-router-dom'
import { LINK_CLASS } from '@/components/ui/Code'
import { cn } from '@/lib/cn'

/** The user card's address (Users opens the drawer from `?user=`): every page links there. */
export function userPath(id: number | string): string {
  return `/users?user=${encodeURIComponent(String(id))}`
}

/**
 * A user id that opens the user card (audit 2026-10-22 §7 P1: «переходы к пользователю
 * отовсюду»). Tabular figures like `Code`, a quiet underline like every admin link (rule 18:
 * no small cyan text). A click inside a clickable row opens the user, not the row's drawer.
 * Without an id — «—».
 */
export function UserLink({
  id,
  label,
  className,
}: {
  id: number | string | null | undefined
  /** what to show instead of the id: «@alice», «tg 12345» */
  label?: string
  className?: string
}) {
  const routed = useInRouterContext()
  if (id === null || id === undefined || id === '') return <span className="text-ink-3">—</span>
  const props = {
    className: cn('tnum whitespace-nowrap', LINK_CLASS, className),
    'aria-label': `Открыть пользователя ${label ?? id}`,
    onClick: (e: { stopPropagation: () => void }) => e.stopPropagation(),
    'data-raw': true,
  }
  // A presentational component rendered on its own (a test, an isolated story) has no router:
  // a plain link to the same address then.
  if (!routed) return <a href={userPath(id)} {...props}>{label ?? String(id)}</a>
  return (
    <Link to={userPath(id)} {...props}>
      {label ?? String(id)}
    </Link>
  )
}
